/**
 * Maze - Renders the Pac-Man maze with entities
 */

import type { Maze as MazeType, PacmanState, GhostState } from '../../types/pacman';
import { TILE_SIZE } from '../../types/pacman';
import { PacmanSprite } from './PacmanSprite';
import { GhostSprite } from './GhostSprite';
import './Maze.css';

interface MazeProps {
  maze: MazeType;
  pacman: PacmanState;
  ghosts: GhostState[];
}

export function Maze({ maze, pacman, ghosts }: MazeProps) {
  const activeGhosts = ghosts.filter(g => !g.isCaptured);

  return (
    <div
      className="maze"
      style={{
        width: maze.width * TILE_SIZE,
        height: maze.height * TILE_SIZE,
      }}
    >
      {/* Cells */}
      {maze.cells.flat().map(cell => (
        <div
          key={`${cell.position.x}-${cell.position.y}`}
          className={`maze-cell maze-cell--${cell.type.toLowerCase()}`}
          style={{
            left: cell.position.x * TILE_SIZE,
            top: cell.position.y * TILE_SIZE,
            width: TILE_SIZE,
            height: TILE_SIZE,
          }}
        />
      ))}

      {/* Ghosts */}
      {activeGhosts.map(ghost => (
        <GhostSprite key={ghost.id} ghost={ghost} />
      ))}

      {/* Pac-Man */}
      <PacmanSprite pacman={pacman} />
    </div>
  );
}
